import React, { useState, useEffect } from 'react';
import './NavActions.scss';
import SearchBar from '../../../components/SearchBar/SearchBar';
import Cart from '../Cart/Cart';
import Wishlist from '../Wishlist/Wishlist';
import UserMenu from '../UserMenu/UserMenu';
import BookEyeTest from '../BookEyeTest/BookEyeTest';

const NavActions = props => {
  const [isSearchActive, setIsSearchActive] = useState(false);

  useEffect(() => {
    const bookEyeEl = document.querySelector('.odBookEyeTest');
    if (bookEyeEl) {
      if (isSearchActive) {
        bookEyeEl.classList.add('odBookEyeTest-hide');
      } else {
        bookEyeEl.classList.remove('odBookEyeTest-hide');
      }
    }
  }, [isSearchActive]);

  return (
    <div className="odNavActions">
      <BookEyeTest />
      <UserMenu />
      <SearchBar
        {...props}
        placeholder="Search"
        setShowBookEyeTest={() => {}}
        setShowInput={setIsSearchActive}
        showInput={isSearchActive}
        triggerDataLayerOnCtaClick={() => {}}
      />
      <Wishlist />
      <Cart />
    </div>
  );
};

export default NavActions;
